import React, { useEffect, useState } from "react";
import "./AssetProfile.css";
import apiClient from "../utils/apiClient";

import {
  FaLaptop,
  FaSearch,
  FaUser,
  FaBuilding,
  FaCalendarAlt,
  FaBarcode,
  FaMicrochip,
  FaCheckCircle,
  FaHistory,
} from "react-icons/fa";

const AssetProfile = () => {
  const [assets, setAssets] = useState([]);
  const [filteredAssets, setFilteredAssets] = useState([]);

  const [selectedAsset, setSelectedAsset] = useState(null);

  const [assetProfile, setAssetProfile] = useState(null);

  const [currentAssignment, setCurrentAssignment] =
    useState(null);

  const [history, setHistory] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");

  const [loading, setLoading] = useState(false);

  const [error, setError] = useState("");

  useEffect(() => {
    fetchAssets();
  }, []);

  /*====================================
      Load Asset List
  ====================================*/

  const fetchAssets = async () => {
    try {
      setLoading(true);

      const data = await apiClient(
        "/assetinventory/inventory/list/"
      );

      const assetList = Array.isArray(data)
        ? data
        : data.results || [];

      /* Remove duplicate asset numbers */

      const uniqueAssets = [];

      const seen = new Set();

      assetList.forEach((item) => {
        if (!seen.has(item.asset_number)) {
          seen.add(item.asset_number);
          uniqueAssets.push(item);
        }
      });

      setAssets(uniqueAssets);

      setFilteredAssets(uniqueAssets);

      if (uniqueAssets.length > 0) {
        loadAssetProfile(uniqueAssets[0].asset_number);
      }

      setLoading(false);
    } catch (err) {
      console.log(err);
      setError("Unable to load assets.");
      setLoading(false);
    }
  };

  /*====================================
      Load Selected Asset
  ====================================*/

  const loadAssetProfile = async (assetNumber) => {
    try {
      setLoading(true);

      const response = await apiClient(
        `/assets/profile/${assetNumber}/`
      );

      setAssetProfile(response.asset);

      setCurrentAssignment(
        response.current_assignment
      );

      setHistory(response.history);

      setSelectedAsset(assetNumber);

      setLoading(false);
    } catch (err) {
      console.log(err);

      setLoading(false);
    }
  };

  /*====================================
      Search Assets
  ====================================*/

  const handleSearch = (value) => {
    setSearchTerm(value);

    if (!value) {
      setFilteredAssets(assets);
      return;
    }

    const filtered = assets.filter(
      (item) =>
        item.asset_number
          ?.toLowerCase()
          .includes(value.toLowerCase()) ||
        item.brand
          ?.toLowerCase()
          .includes(value.toLowerCase()) ||
        item.model
          ?.toLowerCase()
          .includes(value.toLowerCase()) ||
        item.employee_name
          ?.toLowerCase()
          .includes(value.toLowerCase())
    );

    setFilteredAssets(filtered);
  };

  /*====================================
      Status Badge Color
  ====================================*/

  const statusClass = (status) => {
    if (status === "Active")
      return "assetprofile-status-active";

    if (status === "Returned")
      return "assetprofile-status-returned";

    return "assetprofile-status-default";
  };

  if (loading) {
    return (
      <div className="assetprofile-loading">
        Loading Asset Profile...
      </div>
    );
  }

  if (error) {
    return (
      <div className="assetprofile-error">
        {error}
      </div>
    );
  }
    return (
    <div className="assetprofile-page">

      {/* ==========================
            LEFT SIDEBAR
      ========================== */}

      <div className="assetprofile-sidebar">

        <div className="assetprofile-search">

          <FaSearch className="assetprofile-search-icon" />

          <input
            type="text"
            placeholder="Search Asset..."
            value={searchTerm}
            onChange={(e) =>
              handleSearch(e.target.value)
            }
          />

        </div>

        <div className="assetprofile-list">

          {filteredAssets.length > 0 ? (
            filteredAssets.map((item) => (

              <div
                key={item.id}
                className={`assetprofile-list-item ${
                  selectedAsset === item.asset_number
                    ? "assetprofile-active"
                    : ""
                }`}
                onClick={() =>
                  loadAssetProfile(item.asset_number)
                }
              >

                <div className="assetprofile-list-icon">
                  <FaLaptop />
                </div>

                <div className="assetprofile-list-details">

                  <h4>{item.asset_number}</h4>

                  <span>
                    {item.brand} {item.model}
                  </span>

                </div>

              </div>

            ))
          ) : (

            <div className="assetprofile-empty">
              No Assets Found
            </div>

          )}

        </div>

      </div>

      {/* ==========================
            RIGHT CONTENT
      ========================== */}

      <div className="assetprofile-content">

        {/* Header */}

        <div className="assetprofile-header">

          <div>

            <h2>Asset Profile</h2>

            <p>
              View complete assignment history
              of selected asset.
            </p>

          </div>

        </div>

        {/* ==========================
              Asset Details Card
        ========================== */}

        {assetProfile && (

          <div className="assetprofile-card">

            <div className="assetprofile-card-header">

              <FaLaptop />

              <h3>Asset Information</h3>

            </div>

            <div className="assetprofile-grid">

              <div className="assetprofile-item">

                <label>

                    <FaLaptop />

                    Asset Name

                </label>

                <span>
                 {assetProfile.asset_name || currentAssignment?.asset_name || "-"}
                </span>

             </div>

              <div className="assetprofile-item">

                <label>

                  <FaBarcode />

                  Asset Number

                </label>

                <span>
                  {assetProfile.asset_number}
                </span>

              </div>

              <div className="assetprofile-item">

                <label>

                  <FaLaptop />

                  Brand

                </label>

                <span>
                  {assetProfile.brand}
                </span>

              </div>

              <div className="assetprofile-item">

                <label>

                  <FaMicrochip />

                  Model

                </label>

                <span>
                  {assetProfile.model}
                </span>

              </div>

              <div className="assetprofile-item">

                <label>

                  <FaBarcode />

                  Serial Number

                </label>

                <span>
                  {assetProfile.serial_number ||
                    "-"}

                </span>

              </div>

              <div className="assetprofile-item">

                <label>

                  <FaCheckCircle />

                  Status

                </label>

                <span
                  className={statusClass(
                    assetProfile.status
                  )}
                >
                  {assetProfile.status}
                </span>

              </div>

            </div>

          </div>

        )}

        {/* ==========================
            Current Assignment
        ========================== */}

        <div className="assetprofile-card">

          <div className="assetprofile-card-header">

            <FaUser />

            <h3>Current Assignment</h3>

          </div>

          {currentAssignment ? (

            <div className="assetprofile-grid">

              <div className="assetprofile-item">

                <label>

                  <FaUser />

                  Employee

                </label>

                <span>
                  {currentAssignment.employee_name}
                </span>

              </div>

              <div className="assetprofile-item">

                <label>
                  Employee ID
                </label>

                <span>
                  {currentAssignment.employee_id}
                </span>

              </div>

              <div className="assetprofile-item">

                <label>

                  <FaBuilding />

                  Department

                </label>

                <span>
                  {currentAssignment.department}
                </span>

              </div>

              <div className="assetprofile-item">

                <label>
                  Designation
                </label>

                <span>
                  {currentAssignment.designation}
                </span>

              </div>

              <div className="assetprofile-item">

                <label>

                  <FaCalendarAlt />

                  Assigned Date

                </label>

                <span>
                  {currentAssignment.assigned_date}
                </span>

              </div>

            </div>

          ) : (

            <div className="assetprofile-noassignment">

              Available in Asset Pool

            </div>

          )}

        </div>

        {/* ==========================
            Timeline Header
        ========================== */}

        <div className="assetprofile-card">

          <div className="assetprofile-card-header">

            <FaHistory />

            <h3>Assignment History</h3>

          </div>

          <div className="assetprofile-timeline"></div>
                    {history && history.length > 0 ? (

              history.map((item, index) => (

                <div
                  className="assetprofile-timeline-item"
                  key={item.id || index}
                >

                  <div className="assetprofile-timeline-dot"></div>

                  <div className="assetprofile-timeline-card">

                    <div className="assetprofile-timeline-top">

                      <div>

                        <h4>
                          {item.employee_name}
                        </h4>

                        <span>
                          {item.employee_id}
                        </span>

                      </div>

                      <span
                        className={statusClass(item.status)}
                      >
                        {item.status}
                      </span>

                    </div>

                    <div className="assetprofile-history-grid">

                      <div>

                        <label>
                          Department
                        </label>

                        <p>
                          {item.department}
                        </p>

                      </div>

                      <div>

                        <label>
                          Designation
                        </label>

                        <p>
                          {item.designation}
                        </p>

                      </div>

                      <div>

                        <label>
                          Assigned Date
                        </label>

                        <p>
                          {item.assigned_date}
                        </p>

                      </div>

                      <div>

                        <label>
                          Return Date
                        </label>

                        <p>
                          {item.return_date
                            ? item.return_date
                            : "Present"}
                        </p>

                      </div>

                    </div>

                    <div className="assetprofile-remarks">

                      <label>
                        Remarks
                      </label>

                      <p>
                        {item.remarks
                          ? item.remarks
                          : "-"}
                      </p>

                    </div>

                  </div>

                </div>

              ))

            ) : (

              <div className="assetprofile-empty-history">

                No Assignment History Found

              </div>

            )}

          </div>

        </div>

      </div>


  );

};

export default AssetProfile;